module.exports = __webpack_public_path__ + "static/media/approach-restyle.c6e7cfc0.svg";